import React from 'react';
import { Col, FormGroup, InputGroup, FormControl, Button, Pagination, Row } from 'react-bootstrap';
import _ from 'lodash';
import CustomItems from '../components/CustomItems';

class CustomList extends CustomItems {
  /**
   * Validates the properties that are supposed to be shown.
   *
   * @param {Array} propertyArray - array of properties
   */
  validatePropertiesShown = propertyArray => {
    propertyArray.forEach(type => {
      if (typeof this.props[type] !== 'undefined') {
        this.setState({ [type]: this.props[type] });
      }
    });
  };

  /**
   * Handles the search input state.
   *
   * @param {Object} event - event fired on change
   */
  handleSearch = event => {
    const searchValue = event.target.value;
    this.setState({ searchValue });
  };

  /**
   * Gets items of a certain page, and sets that page as the active page.
   *
   * @param {Number} page - page to select
   */
  handlePagination = async page => {
    await this.loadData({
      page,
      search: this.state.searchValue,
      ...this.state._ids,
      all: +!this.state.showPagination,
      filter: this.state.filter,
    });
    this.setState({ activePage: page });
  };

  /**
   * Searches for the items with the given params.
   *
   * @param {String} eventType - type of the event
   * @param {Object} event - event fired
   */
  search = async (eventType, event) => {
    // If onKeyPress, only continue when it's ENTER key
    if (eventType === 'onKeyPress' && event.key !== 'Enter') {
      return;
    }

    await this.loadData({
      ...this.state._ids,
      search: this.state.searchValue,
      all: +!this.state.showPagination,
      filter: this.state.filter,
    });
    this.setState({ activePage: 1 });
  };

  /**
   * Renders the details.
   */
  renderDetails(originalData, button) {
    // Check for 'item.prop' data and copy into the customData
    let customData = _.clone(originalData);
    _.keys(this.state.detailsToShow).forEach(item => {
      if (_.has(originalData, item)) {
        customData[item] = _.get(originalData, item);
      }

      // TODO If arrays exist: check if item includes `[x]` and fetch that item
    });

    // Pick the properties wanted
    const data = _.assign(
      this.state.detailsToShow,
      _.pick(customData, _.keys(this.state.detailsToShow)),
    );

    const items = _.keys(data).map(this.renderItem.bind(this, data));
    return (
      <Row>
        {button && (
          <Col xs={12} className="text-right">
            <Button onClick={() => this.props.history.push(button.link)}>{button.text}</Button>
          </Col>
        )}
        <Col xs={12}>{items}</Col>
      </Row>
    );
  }

  /**
   * Renders the search input and button.
   */
  renderSearch() {
    return (
      <Col xs={12} sm={4}>
        <FormGroup>
          <InputGroup>
            <FormControl
              type="text"
              placeholder="Search..."
              value={this.state.searchValue}
              onChange={this.handleSearch}
              onKeyPress={this.search.bind(this, 'onKeyPress')}
            />
            <InputGroup.Button onClick={this.search}>
              <Button>Search</Button>
            </InputGroup.Button>
          </InputGroup>
        </FormGroup>
      </Col>
    );
  }

  /**
   * Renders the create button.
   */
  renderCreate() {
    return (
      <Col xs={12} sm={4} className="pull-right">
        <Button className="pull-right" onClick={this.redirectToCreate}>
          Create new
        </Button>
      </Col>
    );
  }

  /**
   * Renders the move button.
   */
  renderMove(text) {
    return (
      <Col xs={12} sm={4} className="pull-right">
        <Button className="pull-right" onClick={this.redirectToMove}>
          {text}
        </Button>
      </Col>
    );
  }

  /**
   * Renders the pagination.
   * @param {String} type - type of data from the store
   */
  renderPagination(type) {
    return (
      <Row>
        {this.state.num_pages > 1 && (
          <Col xs={12}>
            <Pagination
              bsSize="medium"
              items={this.state.num_pages}
              maxButtons={5}
              first={true}
              last={true}
              prev={true}
              next={true}
              ellipsis={true}
              activePage={this.state.activePage}
              onSelect={this.handlePagination}
            />
          </Col>
        )}
        {this.state.total_count > 0 && (
          <Col xs={12}>
            Showing {(this.state.activePage - 1) * 10 + 1}-{this.state.total_count <=
            this.state.activePage * 10
              ? this.state.total_count
              : this.state.activePage * 10}{' '}
            of {this.state.total_count}
          </Col>
        )}
      </Row>
    );
  }
}

export default CustomList;



// WEBPACK FOOTER //
// ./src/components/CustomList.js